const header = () => {
  /*
   * SELECTORS
   */
  const els = {
    $header: $('#header'),
    $burger: $('.mobile-burger'),
    $megamenu: $('.main-nav'),
    $navLinks: $('.main-nav li a'),
    $mobileSelectors: $('.mobile-nav, body,#header'),
    $mobileLinks: $('.mobile-nav .nav ul,.mobile-nav .nav .ul ,.mobile-nav .lang-switcher'),
    $mobileNav: $('.mobile-nav'),
    $mobileNavSubnav: $('.mobile-nav .subnav,.mobile-nav .sub-nav,.mobile-nav .sub-subnav'),
    $mobileNavNav: $('.mobile-nav .nav li'),
    $mobileHubNavNav: $('.mobile-nav .nav .li.nesting'),
    $mobileNavSubnavWrapper: $('.mobile-nav .subnav'),
    $mobileNavSubnavWrapperInner: $('.mobile-nav .sub-subnav'),
    $mobileNavSubnavWrapperLinks: $('.mobile-nav .subnav .sub-nav'),
    $mobileNavGoBack: $('.mobile-nav .subnav .label.back'),
    $mobileNavSubGoBack: $('.mobile-nav .sub-subnav .label.back'),
    $mobileNavSubSubnav: $('.mobile-nav .sub-subnav'),
    $mobileSubNavBtn: $('.sub-el.casino'),
    $mobileFitlerPop: $('.mobile-filter-pop'),
  };

  const {
    $header,
    $burger,
    $navLinks,
    $mobileSelectors,
    $mobileLinks,
    $mobileHubNavNav,
    $mobileNav,
    $mobileNavSubnav,
    $mobileNavNav,
    $mobileNavSubnavWrapper,
    $mobileNavSubnavWrapperInner,
    $mobileNavSubnavWrapperLinks,
    $mobileNavGoBack,
    $mobileNavSubGoBack,
    $megamenu,
    $mobileNavSubSubnav,
    $mobileSubNavBtn,
    $mobileFitlerPop,
  } = els;

  const getCurrentUrl = new URL(window.location.href);

  /*
   * EVENTS
   */

  function toggleMNav() {
    $(this).toggleClass('active');
    $mobileSelectors.toggleClass('active');
    $mobileNav.removeClass('down');
    $mobileNavSubnav.removeClass('open');
    $('.right .profile').removeClass('active');
    $('header + .user-dropdown').removeClass('active');
    if ($header.hasClass('sticky')) {
      $mobileNav.addClass('down');
    }
    setTimeout(() => {
      $mobileLinks.toggleClass('visible');
    }, 300);
  }

  function mobileNavLogic() {
    $(this).on('click', function () {
      let data = $(this).attr('data-sub').toLowerCase();
      $mobileNavSubnavWrapper.addClass('open');
      $mobileNavSubnavWrapperLinks.removeClass('open');
      $mobileNavSubnavWrapperLinks.each(function () {
        let innerData = $(this).attr('data-sub').toLowerCase();
        innerData == data && $(this).addClass('open');
        console.log($(this))
      });
    });
  }
  function mobileCasinoLogic() {
    $(this).on('click', function () {
      $mobileNavSubnavWrapperInner.addClass('open');
      let tag = $(this).attr('data-sub')
      $('.mobile-nav .sub-subnav .sub-nav').removeClass('show')
      $(`.mobile-nav .sub-subnav .sub-nav[data-sub="${tag}"]`).addClass('show')
    });
  }

  function mobileGoBack(variant) {
    if (variant == 'casino') {
      $mobileNavSubSubnav.removeClass('open')
    }else if(variant == 'nocasino') {
      $mobileNavSubnav.removeClass('open');
    }
  }

  function markActivePage() {
    let page = $(this).attr('href').replace('/', '');
    if ($('body').hasClass(page)) {
      $(this).addClass('current');
    } else {
      $(this).removeClass('current');
    }
  }
  /*
   * ACTIONS
   */
  $(window).bind('scroll', function () {
    var first = $('main');
    var winOffset_first = first.offset().top - $(window).scrollTop();

    //A fix for landscape - scroll to the end of search bar homepage then made the header sticky
    if (matchMedia('only screen and (max-width: 849px)').matches && getCurrentUrl.pathname == '/') {
      var get_header_height = $header.height();
      var get_search_height = $mobileFitlerPop.height();
      var calcHeaderAndSearch = (get_header_height + get_search_height) - 150;
      if (winOffset_first <= -calcHeaderAndSearch) {
        $header.css('position', 'fixed');
      } else if (winOffset_first >= -calcHeaderAndSearch - 1) {
        $header.css('position', 'absolute');
      }
    } else {
      $header.css('position', 'fixed');
  }

  if (winOffset_first <= -100) {
    $header.addClass('sticky');
  } else if (winOffset_first >= -99) {
    $header.removeClass('sticky');
  }

  });
  $navLinks.each(markActivePage);
  $burger.on('click', toggleMNav);
  $megamenu.on({
    mouseenter: function () {
      $header.addClass('mega');
    },
  });
  $header.on({
    mouseleave: function () {
      $(this).removeClass('mega');
    },
  });

  // mobile menu
  $mobileNavNav.each(mobileNavLogic);
  $mobileHubNavNav.each(mobileNavLogic);
  $mobileSubNavBtn.each(mobileCasinoLogic);
  $mobileNavSubGoBack.on('click', () => mobileGoBack('casino'));
  $mobileNavGoBack.on('click', () => mobileGoBack('nocasino'));
  /*
   * EXTRA EXPORTS
   */
};
export default header;



// WEBPACK FOOTER //
// ./scripts/components/header.js